export default {
	state: {
		ultimoUid: {}
	},
	getters: {
		"ultimoUid": state => state.ultimoUid
	},
	mutations: {
		setUltimoUid(state, payload) {
			state.ultimoUid = payload
		}
	},
	actions: {
		atualizarEstadoUltimoUid({ commit }, payload) {
			commit('setUltimoUid', payload)
		}
	}
};